const CurrencyTypes = {
    USD: 'USD',
    EUR: 'EUR',
    GBP: 'GBP',
    CNY: 'CNY',
    JPY: 'JPY',
    CAD: 'CAD',
    INR: 'INR',
    TWD: 'TWD',
    AUD: 'AUD',
    XOF: 'XOF',
    ILS: 'ILS',
    MXN: 'MXN',
    HKD: 'HKD',
    NZD: 'NZD',
    KRW: 'KRW',
    BRL: 'BRL',
};

export const CURRENCIES: Record<string, string> = {
    [CurrencyTypes.USD]: CurrencyTypes.USD,
    [CurrencyTypes.EUR]: CurrencyTypes.EUR,
    [CurrencyTypes.GBP]: CurrencyTypes.GBP,
    [CurrencyTypes.CNY]: CurrencyTypes.CNY,
    [CurrencyTypes.JPY]: CurrencyTypes.JPY,
    [CurrencyTypes.CAD]: CurrencyTypes.CAD,
} satisfies Partial<Record<keyof typeof CurrencyTypes, string>>;

export const CurrencyCodes: Record<string, string> = {
    [CurrencyTypes.USD]: 'US',
    [CurrencyTypes.BRL]: 'R',
    [CurrencyTypes.JPY]: 'JP',
    [CurrencyTypes.CAD]: 'CA',
    [CurrencyTypes.TWD]: 'NT',
    [CurrencyTypes.AUD]: 'A',
    [CurrencyTypes.XOF]: 'CFA',
    [CurrencyTypes.MXN]: 'MX',
    [CurrencyTypes.HKD]: 'HK',
    [CurrencyTypes.NZD]: 'NZ',
} satisfies Partial<Record<keyof typeof CurrencyTypes, string>>;

export const CurrencySymbols: Record<string, string> = {
    [CurrencyTypes.USD]: '$',
    [CurrencyTypes.EUR]: '€',
    [CurrencyTypes.GBP]: '£',
    [CurrencyTypes.CNY]: '¥',
    [CurrencyTypes.JPY]: '¥',
    [CurrencyTypes.CAD]: '$',
    [CurrencyTypes.INR]: '₹',
    [CurrencyTypes.TWD]: '$',
    [CurrencyTypes.AUD]: '$',
    [CurrencyTypes.ILS]: '₪',
    [CurrencyTypes.MXN]: '$',
    [CurrencyTypes.HKD]: '$',
    [CurrencyTypes.NZD]: '$',
    [CurrencyTypes.KRW]: '₩',
    [CurrencyTypes.BRL]: '$',
} satisfies Partial<Record<keyof typeof CurrencyTypes, string>>;
